import {config} from '../config';


export function addTenant() {
    const currentUser = JSON.parse(localStorage.getItem('acamob_current_user')) || null;
    //console.log("Current user add tenant:", localStorage.getItem('acamob_current_user'), currentUser && currentUser.user && currentUser.user.tenant);
    return { Tenant: `${currentUser && currentUser.user && currentUser.user.tenant || config.tenant}` }
}